import './App.css';
import { createMuiTheme, MuiThemeProvider, responsiveFontSizes } from '@material-ui/core';
import MainLayout from './Layouts/MainLayout';
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import LoginPage from './Pages/LoginPage';
import DocumentsPage from './Pages/DocumentsPage';
import ForgotPasswordRequestPage from './Pages/ForgotPasswordRequestPage';
import ForgotPasswordChangePage from './Pages/ForgotPasswordChangePage';
import ForcePasswordChangePage from './Pages/ForcePasswordChangePage';
import DocumentContextProvider from './Contexts/DocumentContext';

function App() {
  let theme = createMuiTheme({
    palette: {
      primary: {
        main: '#152740'
      }
    },
    typography: {
      fontSize: 16,
      '@media (min-width:600px)': {
        fontSize: 10,
      }
    }
  });

  theme = responsiveFontSizes(theme);

  return (
    <div className="App">
      <MuiThemeProvider theme={theme}>
        <Router>
          <DocumentContextProvider>
            <MainLayout>
              <Switch>
                <Route exact path='/'>
                  <LoginPage />
                </Route>
                <Route exact path='/login'>
                  <LoginPage />
                </Route>
                <Route exact path='/documents'>
                  <DocumentsPage />
                </Route>
                <Route exact path='/forgotpassword'>
                  <ForgotPasswordRequestPage />
                </Route>
                <Route exact path='/changepassword'>
                  <ForgotPasswordChangePage />
                </Route>
                <Route exact path='/choosepassword'>
                  <ForcePasswordChangePage />
                </Route>
              </Switch>
            </MainLayout>
          </DocumentContextProvider>
        </Router>
      </MuiThemeProvider>
    </div>
  );
}

export default App;
